<script setup lang="ts">
import { customPaths } from "~/utils/constants"

interface MobileBackButtonProps {
  label: string
  slug: string
}

withDefaults(defineProps<MobileBackButtonProps>(), {
  label: "Bacheca",
  slug: customPaths.profile.root
})
</script>

<template>
  <div class="bg-grey-main px-4 md:hidden md:bg-white">
    <UtilsButton
      :text="label"
      theme="ghost-black"
      class="inline-flex [&>span]:pl-0"
      :path="slug"
    >
      <template #icon>
        <UtilsIcon name="ArrowLeft.svg" class="icon h-4 w-4" />
      </template>
    </UtilsButton>
  </div>
</template>
